// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"515e73f8","453":"a18adfe5","455":"a3701bf8","977":"00df631b"}[chunkId] + ".chunk.js";
};